import styled from "styled-components";

export const LineNumberLabel = styled.button<{
    backgroundColor: string
}>`
  border: none;
  padding: 0;
  width: 13px;
  height: 13px;
  background-color: ${({backgroundColor}) => backgroundColor};
  font-weight: 900;
  font-size: 10px;
  color: ${(props: any) => props.theme.palette.primitives.white};
  margin: 0 2px 0 0;
`;
